"use client";

import React from "react";
import { StyledStrip } from "./heroPlatformPills.styles";
import { trackEvent } from '@/lib/track';

export interface IPlatformPill {
  name: string;
  // Optional. Hubs whose widget has no published platform spokes omit this,
  // and the pill renders as a plain chip instead of a link to a 404.
  href?: string;
}

interface IHeroPlatformPillsProps {
  label?: string;
  platforms: IPlatformPill[];
  eventName?: string;
}

export const HeroPlatformPills = ({
  label = "Quick add to:",
  platforms,
  eventName,
}: IHeroPlatformPillsProps) => {
  if (!platforms.length) return null;

  return (
    <StyledStrip>
      <span className="label">{label}</span>
      <div className="pills">
        {platforms.map((p) =>
          p.href ? (
            <a
              key={p.name}
              href={p.href}
              className="pill"
              onClick={() => {
                if (eventName) trackEvent(eventName, { platform: p.name });
              }}
            >
              {p.name}
            </a>
          ) : (
            <span key={p.name} className="pill static">
              {p.name}
            </span>
          )
        )}
      </div>
    </StyledStrip>
  );
};
